import { styled } from '@nykaa/ui-components';
import { Dot } from 'shared/styles/assets/icons/components/Dots';

export const Count = styled.span`
  ${({ theme }) => theme.typography.bodyMedium};
  color: ${({ theme }) => theme.colors.textSecondary};
  white-space: nowrap;
`;

export const Separator = styled(Dot)`
  color: ${({ theme }) => theme.colors.textSecondary};
  align-self: center;
  margin: ${({ theme }) => `0 ${theme.spacing.spacing40}`};
`;
